var _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoFavorite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.25,45.08c-.62,0-1.24-.19-1.76-.57-.87-.63-1.34-1.68-1.22-2.75l1.24-11.47L2.76,21.75c-.72-.79-.96-1.92-.63-2.94,.33-1.02,1.19-1.79,2.24-2.01l11.29-2.37,5.74-10c.53-.93,1.53-1.51,2.6-1.51h0c1.07,0,2.07,.58,2.6,1.51h0l5.74,10,11.29,2.37c1.05,.22,1.91,.99,2.24,2.01,.33,1.02,.09,2.14-.63,2.94l-7.74,8.55,1.23,11.47c.12,1.07-.35,2.12-1.22,2.75s-2.02,.75-2.99,.31l-10.52-4.72-10.52,4.72c-.39,.18-.81,.26-1.23,.26Zm25.2-15.24h0Zm-4.89-15.03h0Z",
    fill: filledColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25,45.08c-.62,0-1.24-.19-1.76-.57-.87-.63-1.34-1.68-1.22-2.75l1.24-11.47L2.76,21.74c-.72-.79-.96-1.92-.63-2.94,.33-1.02,1.19-1.79,2.24-2.01l11.29-2.37,5.74-10c.53-.93,1.53-1.51,2.6-1.51h0c1.07,0,2.07,.58,2.6,1.51h0l5.74,10,11.29,2.37c1.05,.22,1.91,.99,2.24,2.01,.33,1.02,.09,2.14-.63,2.94l-7.74,8.55,1.23,11.47c.12,1.07-.35,2.12-1.22,2.75s-2.02,.75-2.99,.31l-10.52-4.72-10.52,4.72c-.39,.18-.81,.26-1.23,.26Zm11.75-9.07c.42,0,.83,.09,1.22,.26l9.35,4.19-1.1-10.18c-.09-.85,.18-1.7,.76-2.34l6.87-7.59-10.02-2.1c-.84-.18-1.56-.7-1.99-1.45l-5.09-8.88-5.1,8.88c-.43,.74-1.15,1.27-1.99,1.44l-10.02,2.1,6.87,7.59c.57,.63,.85,1.48,.76,2.32l-1.1,10.19,9.34-4.19c.39-.17,.81-.26,1.23-.26Zm13.45-6.16h0Zm-4.89-15.03h0Z",
    fill: outlineColor
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 48,
    height: 48,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 48,
    height: 48,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFavorite);
export default __webpack_public_path__ + "static/media/ico-favorite.e1740593ca289eb6afc5d722637d2a26.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = true;